import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import { name, version } from '../../package.json';

assertPackageVersion(name, version);

export { addZerodevExtension } from '../addZerodevExtension';
export type { BatchCall } from '../BatchCall.types';
export { canSponsorUserOperation } from '../canSponsorUserOperation';
export type { CanSponsorUserOperationParams } from '../canSponsorUserOperation';
export { createKernelClientForWalletAccount } from '../createKernelClientForWalletAccount';
export type { Eip7702Authorization } from '../createKernelClientForWalletAccount';
export { estimateUserOperationGas } from '../estimateUserOperationGas';
export type { EstimateUserOperationGasParams } from '../estimateUserOperationGas';
export { getSignerForSmartWalletAccount } from '../getSignerForSmartWalletAccount';
export { isGasSponsorshipError } from '../isGasSponsorshipError';
export type { KernelClient } from '../KernelClient.types';
export { sendUserOperation } from '../sendUserOperation';
export type { SendUserOperationParams } from '../sendUserOperation';
export { signEip7702Authorization } from '../signEip7702Authorization';
export { simulateZerodevUserOperation } from '../simulateZerodevUserOperation';
export { calculateFeeForUserOperation } from '../utils/calculateFeeForUserOperation';
